import { render, staticRenderFns } from "./genre_index.html?vue&type=template&id=2a2d23eb&scoped=true&external"
import script from "./genre_index.vue?vue&type=script&lang=js"
export * from "./genre_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2d23eb",
  null
  
)

export default component.exports